/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { blogPostsData } from './BlogPageData';
import { BlogPostCard } from './BlogPostCard'; // Poprawny import
import './BlogPage.css';


function BlogPage() {
    const [headerRef, isHeaderVisible] = useIntersectionObserver();
    const [postsRef, isPostsVisible] = useIntersectionObserver();

    return (
        <>
            <section ref={headerRef} className={`page-header-section section-bg-white animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>Blog Lingland</h1>
                    <p className="subtitle">Artykuły, porady i analizy ze świata tłumaczeń, języków i komunikacji międzykulturowej. Bądź na bieżąco z trendami w branży!</p>
                </div>
            </section>

            <section className={`blog-list-section section-bg-light-gray`}>
                 <div className="container">
                    <div
                        ref={postsRef}
                        className={`blog-grid blog-page-grid animate-on-scroll ${isPostsVisible ? 'is-visible' : ''}`}
                    >
                        {blogPostsData.map((post) => (
                            <BlogPostCard key={post.id} post={post} />
                        ))}
                    </div>
                 </div>
            </section>
        </>
    );
}

// Usunięto zbędny eksport karty stąd
export default BlogPage;